import { cn } from "@/lib/utils";
import { useTheme } from "@/components/ThemeProvider";
import logoLightText from "@/assets/logo-light-text.png";
import logoDarkText from "@/assets/logo-dark-text.png";
import logoIcon from "@/assets/logo-icon.png";

interface LogoProps {
  variant?: "full" | "icon" | "footer";
  className?: string;
}

/**
 * Brand logo. Picks the dark-text vs light-text wordmark based on active theme
 * so the logo always reads well against the page background.
 */
const Logo = ({ variant = "full", className }: LogoProps) => {
  const { theme } = useTheme();
  // Footer background is always dark (slate-950) regardless of theme — so it
  // always needs the light-text wordmark. For other placements, mirror the page theme.
  const useDarkText = variant !== "footer" && theme === "light";
  const wordmark = useDarkText ? logoDarkText : logoLightText;

  if (variant === "icon") {
    return (
      <img
        src={logoIcon}
        alt="ForexWireDaily"
        className={cn("h-8 w-8 shrink-0", className)}
      />
    );
  }

  const heightClass = variant === "footer" ? "h-7" : "h-9";

  return (
    <img
      src={wordmark}
      alt="ForexWireDaily"
      className={cn(heightClass, "w-auto shrink-0", className)}
    />
  );
};

export default Logo;
